export default __webpack_public_path__ + "static/ukrposhta-5e77b021cb4dfeef109d7cf96cd7bf42.png";